import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import fetch from '../../../../utils/fetch';
import ControlBatchGrid from '../../components/grids/ControlBatchGrid';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

class ControlBatches extends Component {
    state = {
        count: 10,
        generating: false,
    };

    componentWillMount() {
        this.props.breadcrumbs([{ label: 'Generátor kontroly veřejných funkcionářů' }]);
    }

    onRowClick = ({ id }) => {
        this.props.push(`/administrator/kontrola/${id}`);
    }

    onGenerate = async () => {
        this.setState({ generating: true });
        try {
            const response = await fetch(
                `/administrator/api/kontrola/generate?count=${this.state.count}`,
                this.props.dispatch
            );
            if (response.ok) {
                window.location.reload();
            }
        } finally {
            this.setState({ generating: false });
        }
    }

    render() {
        const { count, generating } = this.state;

        return (
            <div>
                <Paper
                    elevation={0}
                    style={{
                        padding: '20px 24px',
                        marginBottom: 24,
                        border: '1px solid #e0e0e0',
                        borderRadius: 4,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 20,
                    }}
                >
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                        Náhodný výběr VF ke kontrole:
                    </Typography>
                    <TextField
                        label="Počet"
                        type="number"
                        size="small"
                        value={count}
                        onChange={(e) => this.setState({ count: Math.max(1, parseInt(e.target.value) || 1) })}
                        style={{ width: 100 }}
                        inputProps={{ min: 1, max: 100 }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.onGenerate}
                        disabled={generating}
                        style={{ color: 'white', padding: '6px 24px' }}
                    >
                        {generating ? 'Generování...' : 'Generovat'}
                    </Button>
                </Paper>

                <ControlBatchGrid
                    gridName="controlBatchGrid"
                    onRowClick={this.onRowClick}
                    url="/administrator/api/kontrola"
                />
            </div>
        );
    }
}

export default connect(
    (state) => ({ auth: state.app.auth }),
    (dispatch) => ({ dispatch, breadcrumbs: (...args) => dispatch(breadcrumbs(...args)), push: (...args) => dispatch(push(...args)) })
)(ControlBatches);